"use client";

import React from "react";
import { Navbar } from "@oreme/ui";
import { SharedMenubar } from "@/components";

function SharedNavbar() {
  return (
    <Navbar title="GPSMob">
      <SharedMenubar />
    </Navbar>
  );
}

export { SharedNavbar };
